import { render } from "./ProtocolSignatoryListPage.vue?vue&type=template&id=29b1531a&scoped=true&ts=true"
import script from "./ProtocolSignatoryListPage.vue?vue&type=script&lang=ts"
export * from "./ProtocolSignatoryListPage.vue?vue&type=script&lang=ts"

import "./ProtocolSignatoryListPage.vue?vue&type=style&index=0&id=29b1531a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b1531a"]])

export default __exports__